import React from "react";
import { useLang, LANG, rem, Stack, BREAKPOINTS, Card } from "@manulife/mux";
import { Manulife, ManulifeFr } from "@manulife/mux-logos";
import useWindowSize from "../customHooks/useWindowSize";
import NumberConstants from "../assets/appStyledComponents/numberConstant.json";
import BannerDesktop from "../assets/images/InsureRightBanner_Desktop.jpg";
import BannerTablet from "../assets/images/InsureRightBanner_Tablet.jpg";
import BannerMobile from "../assets/images/InsureRightBanner_Mobile.jpg";
import Calculater from "../assets/images/Calculater.png";

import {
  PageHeadding,
  ScreenHeadding,
  PageParagraphHeadding,
  NormalText,
} from "../assets/appStyledComponents";
import HomeConstants from "../assets/homeConstants.json";
import { useNavigate } from "react-router-dom";

function Home() {
  const { num13, num30, num290, num400, num2, num32, num40, num80, num64, num20, num192, num24, num144, num1700 } = NumberConstants;
  const { width: windowWidth } = useWindowSize();
  const selectedLang = useLang();

  let bannerImage;
  if (windowWidth > num1700) {
    bannerImage = BannerDesktop;
  } else if (windowWidth > BREAKPOINTS.TABLET_PORTRAIT) {
    bannerImage = BannerTablet;
  } else {
    bannerImage = BannerMobile;
  }

  const styles = {
    logo: {
      height: rem(num30),
      margin: `${rem(num30)} ${rem("0")}`,
    },
  };
  const navigate = useNavigate();

  const cardStyle = windowWidth > BREAKPOINTS.TABLET_LANDSCAPE ? { width: `${rem(num400)}`, height: `${rem(num290)}` } : { width: `100%` };

  const onHover = (e) => {
    e.currentTarget.style.boxShadow = '0 0 20px rgba(0, 0, 0, 0.15)';
  };
  const offHover = (e) => {
    e.currentTarget.style.boxShadow = '';
  };

  const handleCalculatorKeyDown = (event) => {
    const enterKey = num13;
    const spaceBarKey = num32;
    if ([enterKey, spaceBarKey].includes(event.keyCode)) {
      event.preventDefault();
      navigate("/about");
    }
  };

  return (
    <>
      <Stack
        align="flex-start"
        alt=""
        style={{
          backgroundImage: `url(${bannerImage})`,
          alignSelf: `stretch`,
          backgroundPosition: `center`,
          backgroundRepeat: `no-repeat`,
          backgroundSize: `cover`,
        }}
      >
        {windowWidth > BREAKPOINTS.TABLET_LANDSCAPE && (
          <Stack
            align="flex-start"
            style={{
              padding: `${rem(0)} ${rem(num30)}`,
            }}
          >
            <Stack
              direction="row"
              justify="flex-start"
              style={{ width: "100%" }}
            >
              <>
                {selectedLang === LANG.EN_CA ? (
                  <Manulife.WORDMARK_BLACK
                    title="Manulife"
                    style={styles.logo}
                  />
                ) : (
                  <ManulifeFr.WORDMARK_BLACK
                    title="Manuvie"
                    style={styles.logo}
                  />
                )}
              </>
            </Stack>
          </Stack>
        )}
        <PageHeadding
          role="heading"
          aria-level="1"
          style={windowWidth > BREAKPOINTS.TABLET_LANDSCAPE ? { padding: `${rem(0)} ${rem(0)}  ${rem(0)} ${rem(num64)}` } : { padding: `${rem(num32)} ${rem(num24)} ${rem(0)} ${rem(num24)}`, fontSize: rem(num30) }}
        >
          {HomeConstants.pageHeading[`${selectedLang}`]}
        </PageHeadding>
        <PageParagraphHeadding
          role="paragraph"
          style={windowWidth > BREAKPOINTS.TABLET_LANDSCAPE ? { padding: `${rem(0)} ${rem(num64)}  ${rem(num192)}` } : { padding: `${rem(0)} ${rem(num144)} ${rem(num64)} ${rem(num32)}` }}
        >
          {HomeConstants.pageParagraph[`${selectedLang}`]}
        </PageParagraphHeadding>
      </Stack>
      <Stack
        align="flex-start"
        style={{
          padding: `${rem(num40)} ${rem(num64)}  ${rem(num80)} ${rem(num64)}`,
        }}
      >
        <Stack style={{
          padding: `${rem(0)} ${rem(0)}  ${rem(num20)} ${rem(0)}`,
        }}>
          <ScreenHeadding role="heading" aria-level={num2}>
            {HomeConstants.screenHeading[`${selectedLang}`]}
          </ScreenHeadding>
        </Stack>
        <Stack style={{
          padding: `${rem(0)} ${rem(0)}  ${rem(num30)} ${rem(0)}`,
        }}>
          <NormalText>{HomeConstants.screenText[`${selectedLang}`]}</NormalText>
        </Stack>
        <Stack direction="row" justify="space-between" style={{ width: '100%' }}> 
          <a href="/about" className="focus-visible-only" onKeyDown={(e) => { handleCalculatorKeyDown(e) }} style={{ cursor: `pointer`, textDecoration: 'none' }} onMouseOver={onHover} onMouseOut={offHover}>
            <Card customStyle={{ cardStyle }}>
              <Card.Image src={Calculater} alt="" />
              <Card.Header style={{ marginBottom: 0 }} headerLevel={Card.HEADER_LEVEL.H3}>
                {HomeConstants.calculaterHeader[`${selectedLang}`]}
              </Card.Header>
              <Card.Content>
                {HomeConstants.calculaterText[`${selectedLang}`]}
              </Card.Content>
            </Card>
          </a>
        </Stack>
      </Stack>
    </>
  );
};

export default Home;
